// extracted by mini-css-extract-plugin
export default {"alert-icon":"icon_alert-icon__Kpg0P"};